@let active = activeEventOption();
@if (active && active.online) {
    @if (showPossibleWinnings) {
        <div class="scorecast-option-group-col">
            <div class="scorecast-option-group-default-stake">{{ defaultStake() | msCurrency }} {{ symbol + ' ' + infoStakeReturnsText }}</div>
            <div class="scorecast-option-group-possible-return">{{ possibleReturn() | msCurrency }} {{ symbol }}</div>
        </div>
    }
    <div class="scorecast-option-group-col" [ngClass]="showPossibleWinnings ? 'double' : 'single'">
        <ms-option
            [option]="active"
            [optionGroup]="optionGroup"
            [event]="event"
            [tracking]="{ source: tracking, moduleType: trackingModuleType }"
            [sourceOfPick]="sourceOfPick"
            [betDetails]="betDetails" />
    </div>
} @else {
    <div class="scorecast-warning-message">
        <span class="error-icon"><vn-icon name="theme-error-i" size="14" /></span>
        {{ warningMessage }}
    </div>
}
